/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ConcurrentsState } from 'store/modules/concurrents_store/types';
import Loader from 'components/atoms/loader';
import 'moment/locale/pt-br';
import BiddingModal from 'components/atoms/bidding_modal';
import { Container } from './styles';

const StrategicAspects = () => {
  const { concurrents, request } = useSelector<ApplicationState, ConcurrentsState>(
    (state) => state.session.concurrents,
  );
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedBidding, setSelectedBidding] = useState<number | null>(null);
  const sa = concurrents?.strategic_aspects;

  const desCount = Number(sa?.desclassificacoes) || 0;
  const inabCount = Number(sa?.inabilitacoes) || 0;

  const percRaw = sa?.percentuais || { desclassificacoes: 0, inabilitacoes: 0 };
  const desPerc = Number(percRaw.desclassificacoes) || 0;
  const inabPerc = Number(percRaw.inabilitacoes) || 0;

  const motivos = sa?.motivos ?? [];

  const fmtPct = (v: number) =>
    `${v.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;

  const openBidding = (id?: number) => {
    if (!id) return;
    setSelectedBidding(id);
    setShowModal(true);
  };
  return (
    <Container>
      <div className="row d-flex align-items-stretch">
        <div className="col-sm-2">
          <div className="card h-100">
            <div className="card-body">
              <p className="card-text text-dark">Total de disputas:</p>
              <h4 className="card-title font-weight-bold">
                {concurrents?.strategic_aspects?.total_participacoes}
              </h4>
            </div>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="card h-100">
            <div className="card-body">
              <p className="card-text text-dark">Desclassificações:</p>
              <h4 className="card-title font-weight-bold">{desCount}</h4>
            </div>
          </div>
        </div>

        <div className="col-sm-2">
          <div className="card h-100">
            <div className="card-body">
              <p className="card-text text-dark">Inabilitações:</p>
              <h4 className="card-title font-weight-bold">{inabCount}</h4>
            </div>
          </div>
        </div>

        <div className="col-sm-6">
          <div className="card card-progress p-3 h-100">
            <h6 className="card-title font-weight-bold text-dark">
              Desclassificação vs inabilitação em relação ao total participado:
            </h6>

            <div className="mb-2">
              <p className="d-flex align-items-center me-3">
                <span
                  style={{
                    display: 'inline-block',
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    backgroundColor: '#0d6efd',
                    marginRight: 6,
                  }}
                />
                {`Desclassificação ${fmtPct(desPerc)}`}
              </p>

              <p className="d-inline-flex align-items-center">
                <span
                  style={{
                    display: 'inline-block',
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    backgroundColor: '#dc3545',
                    marginRight: 6,
                  }}
                />
                {`Inabilitadas ${fmtPct(inabPerc)}`}
              </p>
            </div>

            <div className="progress">
              <div
                className="progress-bar bg-danger"
                role="progressbar"
                style={{ width: `${inabPerc}%` }}
                aria-valuenow={inabPerc}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-label={`Inabilitadas ${fmtPct(inabPerc)}`}
              />
              <div
                className="progress-bar bg-primary"
                role="progressbar"
                style={{ width: `${desPerc}%` }}
                aria-valuenow={desPerc}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-label={`Desclassificação ${fmtPct(desPerc)}`}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="card card-progress mt-5 p-3">
        <h5 className="title">Principais motivos para Desclassificação / Inabilitação:</h5>

        {request?.strategic_aspects?.loading ? (
          <div className="mt-3">
            <Loader />
          </div>
        ) : (
          <div className="table-responsive mt-2">
            <table className="table table-bordered table-resultados thead-dark">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">N.º CNL</th>
                  <th scope="col">N.º Item</th>
                  <th scope="col">Descrição</th>
                  <th scope="col">Tipo</th>
                  <th scope="col">Portal</th>
                </tr>
              </thead>
              <tbody>
                {motivos.length === 0 ? (
                  <tr>
                    <td colSpan={3} className="text-center text-muted">
                      Não foram encontrados motivos para este CNPJ.
                    </td>
                  </tr>
                ) : (
                  motivos.map((m: any, idx: number) => (
                    <tr key={`${m.tipo}-${m.descricao}-${idx}`}>
                      <td>
                        {m.bidding_id ? (
                          <button
                            type="button"
                            className="btn btn-link p-0"
                            style={{ textDecoration: 'underline' }}
                            onClick={() => openBidding(m.bidding_id)}
                            title="Abrir detalhes do edital"
                          >
                            {m.bidding_id}
                          </button>
                        ) : (
                          '-'
                        )}
                      </td>
                      <td>{m?.numero_item}</td>
                      <td>{m?.descricao}</td>
                      <td>{m?.tipo}</td>
                      <td>{m?.portal}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
        <BiddingModal showModal={showModal} setShowModal={setShowModal} bidding={selectedBidding} />
      </div>
    </Container>
  );
};

export default StrategicAspects;
